export default "__VITE_ASSET__9bd152cc__"